import { FLAGSHIP_LABEL } from 'constants/Enums';
import { useEffect, useState } from 'react';
import { hasFlagshipStoreTag } from 'services/SellerService';

export default function FlagshipLabel({ isVip, isStore, productTags, color = '#B98F0F', isHangDiem = false, hangdiemConfig = {} }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    (async () => {
      setShow((isVip && isStore) || (await hasFlagshipStoreTag(productTags)));
    })();
  }, []);

  if (isHangDiem && hangdiemConfig) {
    //TODO: only display internal config label for HangDiem store
    return (
      <span>
        <span style={hangdiemConfig?.label?.styles}>{hangdiemConfig?.label?.text}</span>
        <span> - </span>
      </span>
    );
  }

  return (
    !!show && (
      <span>
        <span style={{ color }}>{FLAGSHIP_LABEL}</span>
        <span> - </span>
      </span>
    )
  );
}
